import css from "./ReducedMotionIcon.module.scss";

export const ReducedMotionIcon = () => {
	return (
		<svg className={css._} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
			<line x1="33.16" y1="171.73" x2="167.02" y2="37.87" />
			<path d="M112.37,113.73c-.24,1.6-.37,3.24-.37,4.91,0,17.95,14.55,32.5,32.5,32.5s32.5-14.55,32.5-32.5-14.55-32.5-32.5-32.5c-1.67,0-3.31.13-4.91.37" />
			<path d="M102.33,81.35c.35-1.9.54-3.85.54-5.85,0-17.95-14.55-32.5-32.5-32.5s-32.5,14.55-32.5,32.5,14.55,32.5,32.5,32.5c2,0,3.95-.19,5.85-.54" />
			<path
				className={css.fade}
				d="M96.94,129.16c-.24,1.6-.37,3.24-.37,4.91,0,17.95,14.55,32.5,32.5,32.5,12.96,0,24.15-7.59,29.37-18.57"
			/>
			<path
				className={css.moreFade}
				d="M81.51,144.59c-.24,1.6-.37,3.24-.37,4.91,0,17.95,14.55,32.5,32.5,32.5,12.96,0,24.15-7.59,29.37-18.57"
			/>
		</svg>
	);
};
